import React, {PropTypes} from 'react';

const EntryRosterFormVirtualEntriesToModify = ({ 
  captainFirstName,
  captainLastName, 
  virtualEntriesToModify
}) => {
  if (!virtualEntriesToModify || virtualEntriesToModify.length == 0) return null;
  return ( 
    <div>
      <br/>
      {virtualEntriesToModify.map((virtualEntry, rosterIndex) => { 
      
        const bowlerName = `${virtualEntry.displayName} (${virtualEntry.usbcId})`;
        const captainName = `${captainFirstName} ${captainLastName}`;
        let virtualEventName = virtualEntry.virtualEventName;

        return (<div className="alert alert-warning" 
                     key={rosterIndex}> 
                Bowler {bowlerName} is no longer on any of Captain {captainName}'s rosters, if you continue with this removal they will be removed from the {virtualEventName} as well. 
        </div>);
      })}
    </div> 
  );
};

EntryRosterFormVirtualEntriesToModify.propTypes = { 
  virtualEntriesToModify: PropTypes.arrayOf(PropTypes.object),
  captainFirstName: PropTypes.string,
  captainLastName: PropTypes.string
};

EntryRosterFormVirtualEntriesToModify.defaultProps = { 
  virtualEntriesToModify: [],
  captainFirstName: PropTypes.string,
  captainLastName: PropTypes.string
};

export default EntryRosterFormVirtualEntriesToModify;



// WEBPACK FOOTER //
// ./src/features/admin/entryDetail/EntryRosterFormVirtualEntriesToModify.jsx